/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { useTranslations } from "@i18n/react";
import { HallowAnalyticsEvent, useAnalytics } from "@packages/analytics";
import { usePlayer } from "@packages/media";
import { useRequestBackgroundSounds } from "@packages/sdk";
import {
  ModalDropdownMenuHeader,
  ModalDropdownMenuItem,
  ModalTabContent,
  numericViewportHeight,
} from "@packages/ui";

import { useMediaAnalyticsProps } from "../../../../hooks/useMediaAnalyticsProps";
import { VolumeControl } from "../../controls/VolumeControl.emotion";

const loadingStyle: Interpolation = {
  height: numericViewportHeight[100],
};

export const SelectBackgroundTabContent = () => {
  const t = useTranslations();
  const player = usePlayer();
  const { query: bgQuery } = useRequestBackgroundSounds();
  const { track } = useAnalytics();
  const analyticsProps = useMediaAnalyticsProps();

  return (
    <ModalTabContent
      value={"selectBgMenu"}
      key={"selectBgMenu"}
      footer={
        <VolumeControl
          key={"bgVolumeControl"}
          iconColor={"onColorVeryHigh"}
          onOverlay={true}
          value={player?.bgVolume ?? 0.25}
          fullWidth={true}
          onVolumeChange={player ? player.setBgVolume : () => {}}
          onVolumeCommit={(newVol) =>
            track({
              event: HallowAnalyticsEvent.ChangedBackgroundSoundVolume,
              properties: {
                ...analyticsProps,
                background_volume: newVol,
              },
            })
          }
        />
      }
      header={
        <ModalDropdownMenuHeader>
          {t("track_settings_background_sounds")}
        </ModalDropdownMenuHeader>
      }
    >
      <>
        {bgQuery.isPending ? (
          <div css={loadingStyle}>{t("background_sounds_loading")}</div>
        ) : bgQuery.error ? (
          t("background_sounds_error_loading")
        ) : bgQuery.data ? (
          <>
            <ModalDropdownMenuItem
              key={"mediaMenu_selectBgSounds_none_null"}
              selected={!player?.bgId}
              onSelect={() => player?.setBgId(null)}
            >
              {t("web_audio_setting_list_option_background_none")}
            </ModalDropdownMenuItem>
            {bgQuery.data.map((i) => (
              <ModalDropdownMenuItem
                key={`mediaMenu_selectBgSounds_${i.prayer.title.toLowerCase()}_${i.selected_audio.id}`}
                selected={i.selected_audio.id === player?.bgId}
                onSelect={() => {
                  void track({
                    event: HallowAnalyticsEvent.SetBackgroundMusic, // Changed Background Track is a backend event
                    properties: {
                      ...analyticsProps,
                      track: i.selected_audio.id,
                    },
                  });
                  player?.setBgId(i.selected_audio.id);
                }}
              >
                {i.prayer.title}
              </ModalDropdownMenuItem>
            ))}
          </>
        ) : null}
      </>
    </ModalTabContent>
  );
};
